import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import appRoutes from '../../../routes/exams/gmat-focus/app-routes';
import ModalComponent from '../../Common/Modal';
import GMATSubscriptionCheck from '../../RestAPI/GMATFocusSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATFocusSubscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';
/* eslint-disable*/
class BeforeStart extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      status_send: this.props.params.status_send ? this.props.params.status_send : '',
      all_question_id: '',
      question_length: '',
      timer_value: '',
      user_time_value: '',
      include_timer: '',
      questions_count: '',
      allrightanswercount: '',
      offset_send: 0,
      selectedmenu: 'gmat_focus',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      timerInSeconds: 0,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  //Function to redirect page to Create Quiz page
  _createQuizpage = () => {
    this.context.router.push({
      pathname: appRoutes.QUIZZES,
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  //Function to redirect page to begin Quiz page
  beginQuiz = async () => {
    const { all_reading_type, all_cases_id } = this.state;
    var final_exam = [];
    var data = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  if (all_reading_type[0] === 'case_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':case', all_cases_id[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'tab_question') {
                    this.context.router.push({
                      pathname: appRoutes.QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'graph_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'table_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'two_part_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TWO_PART_QUIZ.replace(
                        ':quiz_id',
                        this.state.quiz_id,
                      )
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  }
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected == '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                if (isInArray_var) {
                  if (all_reading_type[0] === 'case_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':case', all_cases_id[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'tab_question') {
                    this.context.router.push({
                      pathname: appRoutes.QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'graph_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'table_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[0] === 'two_part_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TWO_PART_QUIZ.replace(
                        ':quiz_id',
                        this.state.quiz_id,
                      )
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', this.state.offset_send)
                        .replace(':type', all_reading_type[0])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  }
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  /*
  ------------------------------------------------------
      Function to redirect page to begin Quiz page
  ------------------------------------------------------
 */
  viewQuizquestion = async (item, offset_va, e) => {
    const { all_reading_type, all_cases_id } = this.state;
    var final_exam = [];
    var data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  if (all_reading_type[offset_va] === 'case_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':case', all_cases_id[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'tab_question') {
                    this.context.router.push({
                      pathname: appRoutes.QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'graph_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'table_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'two_part_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TWO_PART_QUIZ.replace(
                        ':quiz_id',
                        this.state.quiz_id,
                      )
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  }

                  // this.context.router.push({
                  //   pathname: appRoutes.BEGIN_QUIZ.replace(
                  //     ':quiz_id',
                  //     this.state.quiz_id
                  //   ).replace(':offset', offset_va),

                  // });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected == '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  if (all_reading_type[offset_va] === 'case_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':case', all_cases_id[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'tab_question') {
                    this.context.router.push({
                      pathname: appRoutes.QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'graph_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':offset', offset_va)
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'table_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else if (all_reading_type[offset_va] === 'two_part_question') {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_TWO_PART_QUIZ.replace(
                        ':quiz_id',
                        this.state.quiz_id,
                      )
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  } else {
                    this.context.router.push({
                      pathname: appRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
                        .replace(':offset', offset_va)
                        .replace(':type', all_reading_type[offset_va])
                        .replace(':timer', this.state.timerInSeconds),
                    });
                  }

                  // this.context.router.push({
                  //   pathname: appRoutes.BEGIN_QUIZ.replace(
                  //     ':quiz_id',
                  //     this.state.quiz_id
                  //   ).replace(':offset', offset_va),

                  // });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    //Api to fetch Quiz by quiz id
    FD.callAPI(App_data.backend_api + '/gmat-focus/quizzes/getQuize', data).then(resp => {
      if (resp.success) {
        var retun_all_question = JSON.stringify(resp.singlequiz);
        var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
        let readings = JSON.parse(JSON.parse(retun_all_question)).readings;
        let cases = JSON.parse(JSON.parse(retun_all_question)).cases;

        var question_id = [];
        var reading_id = [];
        var case_id = [];
        //console.log(all_questions);
        for (var i = 0; i < resp.questions_count; i++) {
          question_id.push(all_questions[i]);
          reading_id.push(readings[i]);
          case_id.push(cases[i]);
        }
        console.log('resp.timer_value---', resp.timer_value);
        // var minutes = Math.floor(resp.timer_value / 60);
        const minutes = resp.timer_value / 60;
        this.setState({
          all_question_id: question_id,
          question_length: question_id.length,
          timer_value: minutes,
          include_timer: resp.include_timer,
          user_time_value: resp.user_time_value,
          questions_count: resp.questions_count,
          all_reading_type: reading_id,
          all_cases_id: case_id,
          timerInSeconds: resp.timer_value,
        });
      } else {
        // console.log(resp.success + '------------failure');
      }
      return resp;
    });
    //Api to fetch all right answered on particular quiz id
    FD.callAPI(App_data.backend_api + '/gmat-focus/quizzes/getrightAnswer', data).then(
      resp_count => {
        if (resp_count.success) {
          this.setState({
            allrightanswercount: resp_count.allrightanswercount.count,
          });
        } else {
          // console.log(resp_count.success + '------------failure');
        }
      },
    );
  }

  render() {
    let question_id_display = '';
    const { all_reading_type, token, idname, quiz_id, all_question_id } = this.state;
    if (all_question_id.length) {
      question_id_display = all_question_id.map((items, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td id={'questionNameId_' + index} />
          <td>
            <QuestionChecked
              question_id={items}
              token={token}
              idname={idname}
              quiz_id={quiz_id}
              answered_state={index}
              type={all_reading_type[index]}
            />
          </td>
          <td>
            <a href='javascript: void(0)' onClick={this.viewQuizquestion.bind(this, items, index)}>
              {language.LC().VIEW}
            </a>
          </td>
        </tr>
      ));
    }
    const { timerInSeconds, user_time_value, status_send } = this.state;
    var user_time = '';
    var min,
      sec = '';
    let status_data = '';
    let spentTime = timerInSeconds - user_time_value;
    if (status_send === 'abondon') {
      if (spentTime < 60) {
        user_time = spentTime + 'sec';
      } else {
        min = parseInt(spentTime / 60);
        sec = spentTime % 60;
        user_time = min + 'min ' + sec + 'sec ';
      }

      status_data = (
        <div className='card'>
          <div className='score_wrapper card-block'>
            <div className='row'>
              <div className='col-md-6'>
                <strong className='margin_right_20'>{language.LC().SCORE}</strong>{' '}
                <div className='score_box'>
                  {this.state.allrightanswercount}/{this.state.questions_count}
                </div>
              </div>
              <div className='col-md-6 text-right'>
                <span className='margin_right_20'> {language.LC().TOTAL_TIME}:</span>{' '}
                <strong>{user_time}</strong>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.status_send === 'completed') {
      if (this.state.user_time_value < 60) {
        user_time = this.state.user_time_value + 'sec';
      } else {
        min = parseInt(this.state.user_time_value / 60);
        sec = this.state.user_time_value % 60;
        user_time = min + 'min ' + sec + 'sec ';
      }
      status_data = (
        <div className='card'>
          <div className='score_wrapper card-block'>
            <div className='row'>
              <div className='col-md-6'>
                <strong className='margin_right_20'>{language.LC().SCORE}</strong>{' '}
                <div className='score_box'>
                  {this.state.allrightanswercount}/{this.state.questions_count}
                </div>
              </div>
              <div className='col-md-6 text-right'>
                <span className='margin_right_20'> {language.LC().TOTAL_TIME}:</span>{' '}
                <strong>{user_time}</strong>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let button_status = '';
    if (this.state.status_send === 'abondon') {
      button_status = (
        <button className='btn btn-primary pointer_class' onClick={this.beginQuiz.bind(this)}>
          {' '}
          {language.LC().CONTINUE}
        </button>
      );
    } else if (this.state.status_send === 'completed') {
      button_status = '';
    } else {
      button_status = (
        <button className='btn btn-primary pointer_class' onClick={this.beginQuiz.bind(this)}>
          {' '}
          {language.LC().BEGIN}
        </button>
      );
    }

    return (
      <div className='animated fadeIn'>
        {/* <div className="row"> */}
        <div className='margin_bottom_20 d-flex justify-content-between'>
          {/* <div className="col-md-8 margin_bottom_20"> */}
          <h1 className='section_head'>
            {' '}
            {language.LC().QUIZ_ID}: {this.state.quiz_id}
          </h1>
          {/* </div> */}
          {/* <div className="col-md-4 text-md-right margin_bottom_20"> */}
          <button
            className='btn btn-primary pointer_class'
            onClick={this._createQuizpage.bind(this)}
          >
            {language.LC().CREATE_NEW_QUIZ}
          </button>
          {/* </div> */}
        </div>

        {status_data}

        <div className='row'>
          <div className='col-sm-12'>
            <div className='card'>
              <div className='card-header'>
                {language.LC().SUMMARY}
                <div className='card-actions float-right'>
                  <span className='text_light margin_right_10'>{language.LC().LENGTH}</span>{' '}
                  {this.state.question_length} {language.LC().QUESTIONS}, {this.state.timer_value}{' '}
                  {language.LC().MINUTE}
                </div>
              </div>

              <div className='card-block'>
                <div className='margin_bottom_40'>
                  <p className='margin_bottom_20'>
                    <strong> {language.LC().BEFORE_STARTING} </strong>
                  </p>
                  <p>
                    {
                      language.LC()
                        .ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
                    }
                  </p>
                </div>

                <div className='example_box_wrap'>
                  <p className='margin_bottom_20'>
                    <strong>{language.LC().EXAMPLE}</strong>
                  </p>
                  <hr className='margin_bottom_30' />

                  <div className='row'>
                    <div className='col-md-9'>
                      <ul className='list-inline'>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {language.LC().NO_ANSWER}
                          </span>
                          <span id='quiz_notanswered_status' className='margin_right_60' />
                        </li>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {language.LC().CORRECT_ANSWER}
                          </span>
                          <span id='quiz_answered_status' className='margin_right_60' />
                        </li>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {language.LC().WRONG_ANSWER}
                          </span>
                          <span id='quiz_wrong_answered_status' className='margin_right_60' />
                        </li>
                      </ul>
                    </div>
                    <div className='col-md-3 text-right'>{button_status}</div>
                  </div>

                  {/*<div className="row eg_row">
                                    <div className="eg_box col-md-2 text-center quiz_status_outer" id="quiz_border_blue">
                                        <div className="quiz_status_wrap">
                                            <p>No Answer</p>
                                            <i className="fa fa-circle-thin" id="quiz_notanswered_status"></i>
                                        </div>
                                    </div>
                                    <div className="eg_box col-md-2 text-center quiz_status_outer" id="quiz_border_green">
                                        <div className="quiz_status_wrap">
                                            <p>Correct Answer</p>
                                            <i className="fa fa-circle-thin" id="quiz_answered_status"></i>
                                        </div>
                                    </div>

                                    <div className="eg_box col-md-2 text-center quiz_status_outer" id="quiz_border_red">
                                        <div className="quiz_status_wrap">
                                            <p>Wrong Answer</p>
                                            <i className="fa fa-circle-thin" id="quiz_wrong_answered_status"></i>
                                        </div>
                                    </div>
                                </div>*/}
                </div>
              </div>
            </div>

            <div className='card'>
              <div className='card-header'>{language.LC().YOUR_ANSWERS}</div>

              <div className='table_max_height abandoned_quizzes_cards_scroll'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <thead>
                      <tr className='border_top_0'>
                        <th width='90'>#</th>
                        <th>{language.LC().QUESTIONS}</th>
                        <th>{language.LC().YOURS_ANSWER}</th>
                        <th>{language.LC().ACTION}</th>
                      </tr>
                    </thead>
                    <tbody>{question_id_display}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}
/*This is  child component for checked Question is answered or not*/
function QuestionChecked(props) {
  var data = {
    token: props.token,
    idname: props.idname,
    quiz_id: props.quiz_id,
    question_id: props.question_id,
    type: props.type,
  };
  //Api to check quiz answered of particular question
  FD.callAPI(App_data.backend_api + '/gmat-focus/quizzes/checkAnswered', data).then(resp => {
    if (document.getElementById('questionNameId_' + props.answered_state) !== null)
      document.getElementById('questionNameId_' + props.answered_state).innerHTML =
        resp.questionName;
    if (resp.success) {
      // console.log(resp.question_recived);
      if (resp.question_recived.answer === 1) {
        let userQuestionStatus = document.getElementById(
          'user_question_status' + props.answered_state,
        );
        let answerFlag = document.getElementById('answer_flag' + props.answered_state);
        if (userQuestionStatus) userQuestionStatus.id = 'quiz_answered_status';
        if (answerFlag) answerFlag.innerHTML = `${language.LC().CORRECT_ANSWER}`;
        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
      } else {
        let userQuestionStatus = document.getElementById(
          'user_question_status' + props.answered_state,
        );
        let answerFlag = document.getElementById('answer_flag' + props.answered_state);
        if (userQuestionStatus) userQuestionStatus.id = 'quiz_wrong_answered_status';
        if (answerFlag) answerFlag.innerHTML = `${language.LC().WRONG_ANSWER}`;
        // document.getElementById(
        //   'user_question_status' + props.answered_state
        // ).id = 'quiz_wrong_answered_status';
        //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
        // document.getElementById(
        //   'answer_flag' + props.answered_state
        // ).innerHTML = `${language.LC().WRONG_ANSWER}`;
      }
    } else {
      if (document.getElementById('user_question_status' + props.answered_state) !== null)
        document.getElementById('user_question_status' + props.answered_state).id =
          'quiz_notanswered_status';
      //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
      document.getElementById('answer_flag' + props.answered_state).innerHTML = `${
        language.LC().NO_ANSWER
      }`;
    }
  });
  return (
    <div>
      <span className='margin_right_20' id={'user_question_status' + props.answered_state} />
      <span id={'answer_flag' + props.answered_state} />
    </div>
  );
}

export default BeforeStart;



// WEBPACK FOOTER //
// ./src/views/GMATFocus/Quizzes/BeforeStart.js